import { render } from "./ListTrashReflectionView.vue?vue&type=template&id=cfad7d2e"
import script from "./ListTrashReflectionView.vue?vue&type=script&lang=js"
export * from "./ListTrashReflectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__